import { AfterViewInit, Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-platforms-landing-page',
  templateUrl: './platforms-landing-page.component.html',
  styleUrls: ['./platforms-landing-page.component.css']
})
export class PlatformsLandingPageComponent implements AfterViewInit, OnDestroy {
  private map: any;
  private panIntervalId: any;
  private readonly googleMapsScriptId = 'google-maps-platforms-script';

  private readonly mapStyles = [
    {
      featureType: 'all',
      elementType: 'geometry',
      stylers: [{ color: '#f5f5f5' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#bfeee2' }]
    },
    {
      featureType: 'water',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [{ color: '#f0faf7' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#d9efe8' }]
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#c8e6c9' }]
    },
    {
      featureType: 'administrative',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [{ color: '#b2dfdb' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#a5d6a5' }]
    }
  ];

  ngAfterViewInit(): void {
    this.loadGoogleMaps();
  }

  ngOnDestroy(): void {
    if (this.panIntervalId) {
      clearInterval(this.panIntervalId);
    }

    if ((window as any).initHyderabadMap) {
      delete (window as any).initHyderabadMap;
    }
  }

  onLogoError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='110' height='110' viewBox='0 0 100 100'%3E%3Ccircle cx='50' cy='50' r='45' fill='%23ffffff' opacity='0.3'/%3E%3Ctext x='50' y='65' font-size='14' text-anchor='middle' fill='%23ffffff'%3EBRS%3C/text%3E%3C/svg%3E";
  }

  openProductUrl(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  private async initHyderabadMap(): Promise<void> {
    try {
      const googleMaps = (window as any).google;
      const { Map } = await googleMaps.maps.importLibrary('maps');
      const hyderabad = { lat: 17.385044, lng: 78.486671 };

      this.map = new Map(document.getElementById('map-bg') as HTMLElement, {
        zoom: 11.5,
        center: hyderabad,
        disableDefaultUI: true,
        gestureHandling: 'none',
        styles: this.mapStyles,
        mapTypeId: 'roadmap',
        backgroundColor: '#f0faf7',
        zoomControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
      });

      let step = 0;
      this.panIntervalId = setInterval(() => {
        if (this.map) {
          step += 0.001;
          const lng = 78.486671 + Math.sin(step) * 0.01;
          this.map.panTo({ lat: 17.385044, lng });
        }
      }, 100);
    } catch {
      this.setMapFallbackBackground();
    }
  }

  private loadGoogleMaps(): void {
    (window as any).initHyderabadMap = this.initHyderabadMap.bind(this);

    if ((window as any).google?.maps) {
      this.initHyderabadMap();
      return;
    }

    const existingScript = document.getElementById(this.googleMapsScriptId) as HTMLScriptElement | null;
    if (existingScript) {
      return;
    }

    const script = document.createElement('script');
    script.id = this.googleMapsScriptId;
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCFtEPbFDLNW7muug9RgBKXun_k6iQcBeU&libraries=maps&loading=async&callback=initHyderabadMap';
    script.async = true;
    script.defer = true;
    script.onerror = () => this.setMapFallbackBackground();
    document.head.appendChild(script);
  }

  private setMapFallbackBackground(): void {
    const mapContainer = document.getElementById('map-container');
    if (mapContainer) {
      mapContainer.style.background = 'linear-gradient(135deg, #f0faf7, #d9efe8)';
    }
  }
}
